import { z } from 'zod';
import { iamCancerValidation } from '../../../IamCancerSchema';
import { PcpPatientServiceListSchema } from '../pcp';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiDateSchema } from './AiDateSchema';

export const PcpAiGeneratedSchema = z.object({
  patient: z
    .object({
      iam: iamCancerValidation().nullish(),
    })
    .nullish(),
  dateOfConsultation: AiDateSchema,
  notes: z.string().nullish(),
  patientServices: PcpPatientServiceListSchema,
});

export type PcpAiGenerated = z.infer<typeof PcpAiGeneratedSchema>;

export const PcpAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(PcpAiGeneratedSchema);

export type PcpAiGeneratedResponse = z.infer<
  typeof PcpAiGeneratedResponseSchema
>;
